import React from 'react';
import FileList from 'components/file/list';
import UploadButton from 'components/file/button/upload';
import featureFlags from 'utils/feature_flags';
import { Box, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useMutation } from '@apollo/client/react';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { WhiteCard } from 'components/styles_components/card';

const FileSection = ({ files, uploadMutation, uploadVariables, refetch, canUpload = true }) => {
  const setInfo = useInfo();
  const setError = useError();

  const [upload, { loading }] = useMutation(uploadMutation, {
    onCompleted: (data) => {
      const result = Object.values(data)[0];
      if (result?.externalFile) {
        setInfo('info.file.uploaded');
        refetch();
      } else {
        setError('error.file.upload');
      }
    },
    onError: (error) => {
      if (error.message?.includes('storage') || error.message?.includes('token')) {
        setError('error.storage.not_connected');
      } else {
        setError('error.file.upload');
      }
    },
  });

  const handleFileSelect = (file) => {
    upload({
      variables: {
        ...uploadVariables,
        file,
      },
    });
  };

  if (!featureFlags.STORAGE) { return null; }

  return (
    <WhiteCard>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">
          <FormattedMessage id="files" />
        </Typography>
        {canUpload && <UploadButton onFileSelect={handleFileSelect} loading={loading} />}
      </Box>
      <FileList files={files} onDelete={refetch} canDelete={canUpload} />
    </WhiteCard>
  );
};

export default FileSection;
